<template>
  <div>
    <div class="heading" v-if="$store.state.userInfo.type !== 'CN'">
      <!-- <h2 class="mb-4" align="center">{{ $t('labels.profile') }}</h2> -->
      <p class="py-4" align="center">{{ $t('strings.change_profile_account') }}</p>
    </div>
    <div class="w-full vx-row mx-auto">
      <div class="vx-col sm: w-full md:w-1/2 lg:w-1/2 mt-4 sm: p-0 md:pl-0 md:pr-4">
        <label>{{$t('labels.name')}}</label>
        <vs-input
          type="text"
          class="w-full mt-1"
          name="name"
          :placeholder="$t('labels.name')"
          icon-pack="feather"
          icon="icon-user"
          v-model="name"
          icon-no-border
          v-validate="'max:255'"
        />
        <span class="text-danger text-sm">{{ errors.first('name') }}</span>
      </div>
      <div class="vx-col sm: w-full md:w-1/2 lg:w-1/2 mt-4 sm: p-0 md:pr-0 md:pl-4">
        <label>{{$t('labels.organisation_name')}}</label>
        <vs-input
          type="text"
          class="w-full mt-1"
          name="org_name"
          icon-pack="feather"
          icon="icon-grid"
          icon-no-border
          :placeholder="$t('labels.organisation_name')"
          v-model="organisation_name"
          v-validate="'max:255'"
        />
        <span class="text-danger text-sm">{{ errors.first('org_name') }}</span>
      </div>
      <div class="vx-col sm: w-full md:w-1/2 lg:w-1/2 mt-4 sm: p-0 md:pl-0 md:pr-4">
        <label>{{$t('labels.email')}}</label>
        <vs-input
          type="email"
          class="w-full mt-1"
          disabled
          name="email"
          icon-pack="feather"
          icon="icon-mail"
          icon-no-border
          :placeholder="$t('labels.email')"
          v-model="email"
        />
      </div>
      <div class="vx-col sm: w-full md:w-1/2 lg:w-1/2 type mt-4 md:pr-0 md:pl-4">
        <label>{{$t('labels.type')}}</label>
        <vs-input
          type="email"
          disabled
          class="w-full mt-1"
          name="type"
          icon-pack="feather"
          icon="icon-type"
          icon-no-border
          :placeholder="$t('labels.type')"
          :value="type | getUserType"
        />
      </div>
    </div>
    <div class="vx-row w-full mt-6 m-0">
      <div class="vx-col sm: w-full p-0">
        <div class="flex justify-center">
          <vs-button
            color="primary"
            class="mr-4 back-btn"
            @click="goBack()"
          >{{ $t('labels.cancel') }}</vs-button>
          <vs-button
            class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            :disabled="button_loading"
            id="update-profile"
            @click.prevent="updateProfile()"
          >{{ $t('labels.save_profile') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      organisation_name: "",
      type: "",
      subtype: "",
      role_id: null,
      id: null
    };
  },

  mounted() {
    this.setValidationMessage();
    this.setProfile();
    //  this.$store.commit("UPDATE_TAB", 0);
  },
  methods: {
    async setProfile() {
      let p = this.$store.state.userInfo;
      this.name = p.name;
      this.organisation_name = p.organisation_name;
      this.email = p.email;
      this.type = p.type;
      this.subtype = p.subtype;
      this.role_id = p.role_id;
      this.id = p.id;
    },
    // Update Profile Integration API
    async updateProfile() {
      let input = {
        name: this.name,
        organisation_name: this.organisation_name
      };
      let response = await this.getHTTPPostResponse(
        "/update-profile",
        input,
        "#update-profile",
        true
      );
      if (response) {
        let userInfo = {
          name: this.name,
          email: this.email,
          organisation_name: this.organisation_name,
          type: this.type,
          subtype: this.subtype,
          role_id: this.role_id,
          id: this.id
        };
        localStorage.setItem("user", JSON.stringify(userInfo));
        this.$store.dispatch("updateUser", userInfo);
        this.$store.commit("resetState", null, { module: "userData" });
        //this.$router.push({ name: "Dashboard" });
        history.back();
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
</style>


